export const FLAG_CATEGORIES = [
  { key: "child_safety", label: "Child safety (CSAE)" },
  { key: "community_rules", label: "Community rules" },
  { key: "threatening_violence", label: "Threatening violence" },
  { key: "harassment", label: "Harassment or bullying" },
  { key: "non_consensual_intimate_imagery", label: "Non-consensual intimate imagery" },
  { key: "self_harm", label: "Self-harm or suicide" },
  { key: "impersonation", label: "Impersonation" },
  { key: "racial_slur", label: "Racial slur" },
  { key: "ethnic_slur", label: "Ethnic slur" },
  { key: "sexual_orientation_slur", label: "Sexual orientation slur" },
  { key: "gender_identity_slur", label: "Gender identity slur" },
  { key: "religious_slur", label: "Religious slur" },
  { key: "profanity", label: "Profanity" },
  { key: "spam", label: "Spam" },
] as const;

export type FlagCategoryKey = (typeof FLAG_CATEGORIES)[number]["key"];

export const FLAG_CATEGORY_KEYS: readonly FlagCategoryKey[] =
  FLAG_CATEGORIES.map((c) => c.key);

export const FLAG_CATEGORY_LABELS: Record<FlagCategoryKey, string> =
  FLAG_CATEGORIES.reduce(
    (acc, c) => {
      acc[c.key] = c.label;
      return acc;
    },
    {} as Record<FlagCategoryKey, string>,
  );
